import React from 'react';
import Field from 'redux-form/es/Field';
import { FormattedMessage } from 'react-intl';
import QuestionText from '../reusable/QuestionText';
import InputField from '../../../Core/Controls/InputField';
import { fieldNames } from '../const';
import RadioBoxesWithInput from '../reusable/RadioBoxesWithInput';

const OtherExpensesQuestion = () => {
  const otherExpensesOptions = [
    {
      title: 'followup.question.otherExpenses.discretionary',
      value: 'DISCRETIONARY',
    },
    {
      title: 'followup.question.essentialNeeds.mandatory',
      value: 'MANDATORY',
    },
  ];

  return (
    <div className="followup__question-container">
      <QuestionText textId="followup.question.otherExpenses" />

      <Field
        type="text"
        component={InputField}
        name={fieldNames.otherExpensesClarification}
        isFullWidth
        title={<FormattedMessage id="followup.question.otherExpenses.clarification" />}
        isErrorVisible
      />

      <RadioBoxesWithInput
        fieldName={fieldNames.otherExpenses}
        options={otherExpensesOptions}
      />
    </div>
  );
};

export default OtherExpensesQuestion;
